import { SAVED_SEARCHES } from 'tradera/constants/cookies';
import { useCookieUtil } from 'tradera/hooks/use-cookie-util';
import cookieUtil from 'tradera/utils/cookie';

/**
 * To have the cookie string as compact as possible the values are stored as
 * "id_count#id_count#id_count"
 */

export type ParsedSavedSearch = {
    id: number;
    count: number;
};

export const toSavedSearchesFromCookieString = (
    cookieString: string,
): ParsedSavedSearch[] => {
    const savedSearches = cookieString.split('#');

    if (!savedSearches || savedSearches.length === 0) return [];

    return savedSearches.map((search) => {
        const [id, count] = search.split('_');
        return { id: Number(id), count: Number(count) };
    });
};

export const storeSavedSearch = (id: number, count: number) => {
    const savedSearches = toSavedSearchesFromCookieString(
        cookieUtil.getCookie(SAVED_SEARCHES) ?? '',
    );

    if (Number.isNaN(count)) return;

    const newSavedSearches = [
        ...savedSearches.filter(
            (search) => search.id !== id && !Number.isNaN(search.count),
        ),
        { id, count },
    ];

    cookieUtil.createCookie(
        SAVED_SEARCHES,
        newSavedSearches
            .map((search) => `${search.id}_${search.count}`)
            .join('#'),
        365,
    );
};

export const removeSavedSearch = (id: number) => {
    const savedSearches = toSavedSearchesFromCookieString(
        cookieUtil.getCookie(SAVED_SEARCHES) ?? '',
    );
    const newSavedSearches = [
        ...savedSearches.filter((search) => search.id !== id),
    ];

    cookieUtil.createCookie(
        SAVED_SEARCHES,
        newSavedSearches
            .map((search) => `${search.id}_${search.count}`)
            .join('#'),
    );
};

export const useGetSavedSearchesInCookies = () => {
    const cookieUtil = useCookieUtil();
    const savedSearches = cookieUtil.getCookie(SAVED_SEARCHES);

    return toSavedSearchesFromCookieString(savedSearches ?? '');
};
